import { render, staticRenderFns } from "./ComplaintManageTracking.vue?vue&type=template&id=900dd800&"
import script from "./ComplaintManageTracking.vue?vue&type=script&lang=js&"
export * from "./ComplaintManageTracking.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintManageTracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports